import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { Container } from './styles';

const Field = ({ label, error, id, onBlur, ...props }) => {
  return (
    <Container error={error}>
      <label htmlFor={id}>{label}</label>
      <InputMask data-testid="input" {...props} id={id} />
      {error && <span data-testid="validator">{error}</span>}
    </Container>
  );
};

export default Field;

Field.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  onBlur: PropTypes.func,
};

Field.defaultProps = {
  placeholder: 'Placeholder',
  label: 'Label',
  id: 'name',
  error: null,
  onBlur: null,
  value: '',
  onChange: (event) => event,
};
